<template>
  <div>
    <div class="subtitle-2 mb-2">{{ $t('crudUnidades.form.fields.referentes') }}</div>
    <div
      v-for="(grupo, index) in grupos"
      :key="grupo._key"
      class="unidade-referente-card mb-2 pa-3"
    >
      <v-row align="center" no-gutters>
        <v-col cols="11" class="pr-2">
          <MultiplaEscolha
            lazy
            get-url="getUsuarioslazy"
            text="nome_usuario"
            value="id_usuario"
            :items="grupo.usuariosOptions || []"
            :label="$t('user.username')"
            :max-items="3"
            :rules="userRulesForGrupo(grupo)"
            class="mb-2"
            v-bind:selected-items.sync="grupo.idUsuarios"
          />
          <v-select
            v-model="grupo.id_label_referente"
            :items="labelOptions"
            item-text="label"
            item-value="id_label_referente"
            :label="$t('crudUnidades.form.fields.referenteLabel')"
            :rules="labelRulesForGrupo(grupo)"
            dense
            outlined
            clearable
            class="merus-select"
          />
        </v-col>
        <v-col cols="1" class="d-flex justify-end align-center">
          <v-btn
            icon
            x-small
            :title="$t('button.delete')"
            @click="$emit('remove', index)"
          >
            <v-icon small color="red">mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn
      text
      small
      color="primary"
      class="mb-3 px-0"
      @click="$emit('add')"
    >
      + {{ $t('crudUnidades.form.fields.addReferenteType') }}
    </v-btn>
  </div>
</template>

<script>
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
  name: 'UnidadeReferentesEditor',
  components: { MultiplaEscolha },
  props: {
    grupos: {
      type: Array,
      required: true,
    },
    labelOptions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    grupoTemUsuarios(grupo) {
      return Array.isArray(grupo && grupo.idUsuarios)
        && grupo.idUsuarios.some((id) => Number(id) > 0);
    },
    grupoTemLabel(grupo) {
      const id = Number(grupo && grupo.id_label_referente);
      return Number.isFinite(id) && id > 0;
    },
    labelRulesForGrupo(grupo) {
      if (!this.grupoTemUsuarios(grupo)) {
        return [];
      }
      return [
        (v) => {
          const id = Number(v);
          return (Number.isFinite(id) && id > 0)
            || this.$t('crudUnidades.validation.referenteLabelRequired');
        },
      ];
    },
    userRulesForGrupo(grupo) {
      if (!this.grupoTemLabel(grupo)) {
        return [];
      }
      return [
        (v) => {
          const list = Array.isArray(v) ? v : [];
          const hasUsers = list.some((id) => Number(id) > 0);
          return hasUsers || this.$t('crudUnidades.validation.referenteUsersRequired');
        },
      ];
    },
  },
};
</script>

<style scoped>
.unidade-referente-card {
  border: 1px solid rgba(0, 0, 0, 0.28);
  border-radius: 8px;
}
</style>
